// src/api/authApi.js
import axios from "axios";
import { supabase } from "../supabaseClient";

//const API_URL = "http://localhost:5000/api"; // Change for production
const API_URL = "https://beskar-one-backend.vercel.app/api";

export async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const session = data?.session;
  if (session?.access_token) {
    return { Authorization: `Bearer ${session.access_token}` };
  }
  return {};
}

// Settings
export async function getSettings() {
  const headers = await authHeaders();
  return axios.get(`${API_URL}/settings`, { headers });
}
export async function updateSettings(data) {
  const headers = await authHeaders();
  return axios.put(`${API_URL}/settings`, data, { headers });
}

// Dashboard
export async function getDashboardTransactions() {
  const headers = await authHeaders();
  return axios.get(`${API_URL}/dashboard`, { headers });
}

// Rules: Now using one row per user, all booleans as object
export async function getRules() {
  const headers = await authHeaders();
  return axios.get(`${API_URL}/rules`, { headers });
}
export async function updateRules(data) {
  const headers = await authHeaders();
  return axios.put(`${API_URL}/rules`, data, { headers });
}

// Templates: Now using one row per user, all booleans as object
export async function getTemplates() {
  const headers = await authHeaders();
  return axios.get(`${API_URL}/templates`, { headers });
}
export async function updateTemplates(data) {
  const headers = await authHeaders();
  return axios.put(`${API_URL}/templates`, data, { headers });
}

// Blocklist
export async function getBlocklist() {
  const headers = await authHeaders();
  return axios.get(`${API_URL}/blocklist`, { headers });
}
export async function updateBlocklist({ countries, email_providers }) {
  const headers = await authHeaders();
  return axios.put(`${API_URL}/blocklist`, { countries, email_providers }, { headers });

}
